import '../../asset/css/main.css';

export function Badge({ type, children }) {
  return <span className={`badge badge-${type}`}>{children}</span>;
}

export function PulseDot() {
  return <span className="dot" />;
}

export function statusBadge(s) {
  if (s === 'Under Review') return <Badge type="gold">⏳ Under Review</Badge>;
  if (s === 'Scored')       return <Badge type="green">✓ Scored</Badge>;
  if (s === 'pending')      return <Badge type="red">● Pending</Badge>;
  if (s === 'scored')       return <Badge type="green">✓ Scored</Badge>;
  return <Badge type="blue">{s}</Badge>;
}

export function ProgressBar({ pct, color = 'var(--gold)', height = 5 }) {
  return (
    <div className="prog-wrap" style={{ height }}>
      <div className="prog-fill" style={{ width: `${pct}%`, background: color }} />
    </div>
  );
}

export function ActivityList({ items }) {
  return (
    <div className="act-list">
      {items.map((a, i) => (
        <div className="act-item" key={i}>
          <div className="act-ico" style={{ background: a.bg }}>{a.icon}</div>
          <div>
            <div className="act-text">
              <strong>{a.label}</strong>
              {a.detail ? ` — ${a.detail}` : ''}
            </div>
            <div className="act-time">{a.time}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

export function Panel({ title, children, style, className = '' }) {
  return (
    <div className={`panel ${className}`} style={style}>
      {title && <div className="panel-title">{title}</div>}
      {children}
    </div>
  );
}

export function StatCard({ icon, cls, val, label, delta, up, accent }) {
  return (
    <div className={`stat-card${accent ? ' accent-gold' : ''}`}>
      <div className={`stat-ico ico-${cls}`}>{icon}</div>
      <div>
        <div className="stat-val">{val}</div>
        <div className="stat-lbl">{label}</div>
        {delta && <div className={`stat-delta ${up ? 'up' : 'down'}`}>{delta}</div>}
      </div>
    </div>
  );
}

export function TrackCell({ img, title, sub }) {
  return (
    <div className="td-track">
      <img src={img} alt={title} className="td-thumb" />
      <div>
        <div className="td-name">{title}</div>
        <div className="td-sub">{sub}</div>
      </div>
    </div>
  );
}